// removed by extract-text-webpack-plugin
module.exports = {"component":"_1_5aejAL33qWDiJdS3wbgl","title":"_3tGoj4fW6-fzUBLScHsRda","field":"_2o2YCugnQcYPCjIbSzHVRA","label":"_1Umjeo-ZkraaqEXTyrWPJt","input":"_28NX-6ZErKcgDREZFXFLAG","btn":"_3XnK_nSbFL9JMIZTMAUDmm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MerchantAuthenticationForm/MerchantAuthenticationForm.scss
 ** module id = 993
 ** module chunks = 0
 **/